<template>
  <div>
    <router-view />
    <ProfileUpdatedNotification />
    <Loader />
  </div>
</template>

<script>
import SharedMixin from '@/modules/shared/mixins/shared.mixin';
import ProfileUpdatedNotification from '@/modules/shared/components/core/ProfileUpdatedNotification.vue';
import Loader from '@/modules/shared/components/core/Loader.vue';
export default {
  components: { ProfileUpdatedNotification, Loader },
  name: 'App',
  mixins: [SharedMixin]
};
</script>
